export const environment = {
  production: false,
  baseUrl: 'https://api.uat.invest-01.cadaa.co/',
  defaultLang: 'ar',
  xAuthKey: 'H3toogztuzhDDaZoMZ9ilNuyIiuna9ARH6E7eXFmLM1REoE30T0kvj2NbkJD59TH',
  environment: 'uat',
  firebase: {
    apiKey: 'AIzaSyBozFOwIHmtg1iFsV7jSX5Ayo6OWfyZSl0',
    authDomain: 'invest-01---uat.firebaseapp.com',
    projectId: 'invest-01---uat',
    storageBucket: 'invest-01---uat.firebasestorage.app',
    messagingSenderId: '807530320865',
    appId: '1:807530320865:web:5807e9c1c8dd47d54778a0',
    measurementId: 'G-GKCNH91MYH',
  },
};
